import { Card,Divider,Stack } from '@mui/material';
import { useContext } from 'react';
import { NewFormContext } from '../../context/NewFormContext';
import Chamados from './Chamados';
import Notificacoes from './Notificacoes';


export default function ChamadosENotificacao() {
  const { modelo } = useContext(NewFormContext);
  return (
    <Card sx={{ width: '100%', padding: 2 }}>
      <Stack direction='row' justifyContent='flex-start' alignItems='flex-start' width='100%' spacing={1.5}>
        <Chamados />
        {!modelo?.preenchimentoDeslogado &&
          <>
            <Divider orientation='vertical' flexItem variant='middle' />
            <Notificacoes />
          </>
        }
      </Stack>
    </Card>
  );
}
